import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { MainButton } from '../../../../components/Buttons/MainButton';
import { colors } from '../../../../theme/colors';
import { fontSize } from '../../../../theme/typography';
import { accountSettingsCardFieldStyles, settingTitleStyles } from '../styles';
import LanguageSelectionDialog from './LanguageSelectionDialog';

const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'lt', label: 'Lietuvių' },
];

const AccountSettingsLanguageField = () => {
  const { i18n } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem('preferredLanguage', languageCode);
    window.location.reload();
  };

  const currentLanguage = SUPPORTED_LANGUAGES.find(
    (lang) => lang.code === i18n.language,
  );

  return (
    <>
      <div style={accountSettingsCardFieldStyles}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div>
            <div style={settingTitleStyles}>
              {t('accountSettings.language')}
            </div>
            <div
              style={{
                color: colors.textGreyMedium,
                fontSize: fontSize.regular,
              }}
            >
              {currentLanguage?.label}
            </div>
          </div>
          <MainButton
            onClick={() => setIsDialogOpen(true)}
            variant="outlined"
            size="small"
            typeStyle="secondary"
            text={t('common.change')}
          />
        </div>
      </div>

      <LanguageSelectionDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onLanguageSelect={handleLanguageChange}
        currentLanguageCode={i18n.language}
      />
    </>
  );
};

export default AccountSettingsLanguageField;
